module.exports = __webpack_public_path__ + "img/samsung-galaxy-a20.7797c485.jpg";